const e = "Aparthotele", s = "Apartamenty", o = "Biznes", n = "Obozowisko", t = "Dla par", i = "Dla rodzin", r = "Dla przyjaciół", a = "Hostele", l = "Hotels", c = "Ośrodki wypoczynkowe", p = "Restauracje", y = {
  "{num} reviews": "{num} recenzji",
  "<em>TOP {position}</em> {hotelType} in {location}": "<em>TOP {position}</em> {hotelType} w {location}",
  "All languages": "Wszystkie języki",
  "All traveler types": "Wszystkie typy podróżnych",
  Aparthotels: e,
  Apartments: s,
  "Arrow icon": "Ikona strzałki",
  "B&Bs": "B&Bs",
  "based on {number} reviews": "na podstawie {number} recenzji",
  Business: o,
  Campsites: n,
  Couple: t,
  Family: i,
  Friend: r,
  "Highlighted reviews": "Wyróżnione recenzje",
  Hostels: a,
  Hotels: l,
  "Information icon": "Ikona informacji",
  "No reviews found": "Nie znaleziono żadnych recenzji",
  "Pet-friendly": "Przyjazny dla zwierząt",
  "Posted on {reviewer}": "Opublikowano na {reviewer}",
  "Read Reviews": "Przeczytaj recenzje",
  Resorts: c,
  Restaurants: p,
  "Review Summary": "Opinie gości",
  "Reviews by Source": "Recenzje według źródła"
};
export {
  e as Aparthotels,
  s as Apartments,
  o as Business,
  n as Campsites,
  t as Couple,
  i as Family,
  r as Friend,
  a as Hostels,
  l as Hotels,
  c as Resorts,
  p as Restaurants,
  y as default
};
//# sourceMappingURL=pl.DKSX3qtM.js.map
